import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white edit-course-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-12" }
const _hoisted_5 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_6 = { class: "mb-0" }
const _hoisted_7 = { class: "col-md-12" }
const _hoisted_8 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_9 = { class: "col-md-12" }
const _hoisted_10 = {
  class: "accordion mb-15 mb-sm-20 mb-md-25 mb-lg-30",
  id: "tableOfContentAccordion"
}
const _hoisted_11 = { class: "accordion-item border-0" }
const _hoisted_12 = {
  id: "TableContentCollapseOne",
  class: "accordion-collapse collapse show",
  "data-bs-parent": "#tableOfContentAccordion"
}
const _hoisted_13 = { class: "accordion-body" }
const _hoisted_14 = { class: "ps-0 mb-0 list-unstyled" }
const _hoisted_15 = { class: "d-flex justify-content-between" }
const _hoisted_16 = { class: "d-flex justify-content-between" }
const _hoisted_17 = { class: "d-flex justify-content-between" }
const _hoisted_18 = { class: "d-flex justify-content-between" }
const _hoisted_19 = { class: "d-flex justify-content-between" }
const _hoisted_20 = { class: "accordion-item border-0" }
const _hoisted_21 = {
  id: "TableContentCollapseTwo",
  class: "accordion-collapse collapse",
  "data-bs-parent": "#tableOfContentAccordion"
}
const _hoisted_22 = { class: "accordion-body" }
const _hoisted_23 = { class: "ps-0 mb-0 list-unstyled" }
const _hoisted_24 = { class: "d-flex justify-content-between" }
const _hoisted_25 = { class: "d-flex justify-content-between" }
const _hoisted_26 = { class: "d-flex justify-content-between" }
const _hoisted_27 = { class: "d-flex justify-content-between" }
const _hoisted_28 = { class: "d-flex justify-content-between" }
const _hoisted_29 = { class: "accordion-item border-0" }
const _hoisted_30 = {
  id: "TableContentCollapseThree",
  class: "accordion-collapse collapse",
  "data-bs-parent": "#tableOfContentAccordion"
}
const _hoisted_31 = { class: "accordion-body" }
const _hoisted_32 = { class: "ps-0 mb-0 list-unstyled" }
const _hoisted_33 = { class: "d-flex justify-content-between" }
const _hoisted_34 = { class: "d-flex justify-content-between" }
const _hoisted_35 = { class: "d-flex justify-content-between" }
const _hoisted_36 = { class: "d-flex justify-content-between" }
const _hoisted_37 = { class: "d-flex justify-content-between" }
const _hoisted_38 = { class: "accordion-item border-0" }
const _hoisted_39 = {
  id: "TableContentCollapseFour",
  class: "accordion-collapse collapse",
  "data-bs-parent": "#tableOfContentAccordion"
}
const _hoisted_40 = { class: "accordion-body" }
const _hoisted_41 = { class: "ps-0 mb-0 list-unstyled" }
const _hoisted_42 = { class: "d-flex justify-content-between" }
const _hoisted_43 = { class: "d-flex justify-content-between" }
const _hoisted_44 = { class: "d-flex justify-content-between" }
const _hoisted_45 = { class: "d-flex justify-content-between" }
const _hoisted_46 = { class: "d-flex justify-content-between" }
const _hoisted_47 = { class: "accordion-item border-0" }
const _hoisted_48 = {
  id: "TableContentCollapseFive",
  class: "accordion-collapse collapse",
  "data-bs-parent": "#tableOfContentAccordion"
}
const _hoisted_49 = { class: "accordion-body" }
const _hoisted_50 = { class: "ps-0 mb-0 list-unstyled" }
const _hoisted_51 = { class: "d-flex justify-content-between" }
const _hoisted_52 = { class: "d-flex justify-content-between" }
const _hoisted_53 = { class: "d-flex justify-content-between" }
const _hoisted_54 = { class: "d-flex justify-content-between" }
const _hoisted_55 = { class: "d-flex justify-content-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QuillEditor = _resolveComponent("QuillEditor")!
  const _component_ImageUpload = _resolveComponent("ImageUpload")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", null, [
        _createElementVNode("div", _hoisted_3, [
          _cache[58] || (_cache[58] = _createElementVNode("div", { class: "col-md-12" }, [
            _createElementVNode("div", { class: "form-group mb-15 mb-sm-20 mb-md-25" }, [
              _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Course Title "),
              _createElementVNode("input", {
                type: "text",
                class: "form-control shadow-none rounded-0 text-black",
                placeholder: "e.g. AI Machine Learning"
              })
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[0] || (_cache[0] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Course Description ", -1)),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_QuillEditor, {
                  theme: "snow",
                  placeholder: "Write your meta description",
                  toolbar: "full"
                })
              ])
            ])
          ]),
          _cache[59] || (_cache[59] = _createStaticVNode("<div class=\"col-md-12\"><div class=\"form-group mb-15 mb-sm-20 mb-md-25\"><label class=\"d-block text-black fw-semibold mb-10\"> Select Category </label><select class=\"form-select shadow-none fw-semibold rounded-0\"><option selected>Artificial Inteligence (AI)</option><option value=\"1\">Web Development</option><option value=\"2\">Entrepreneurship</option><option value=\"3\">Management</option><option value=\"4\">Business Strategy</option></select></div></div><div class=\"col-md-6\"><div class=\"form-group mb-15 mb-sm-20 mb-md-25\"><label class=\"d-block text-black fw-semibold mb-10\">Price</label><div class=\"input-group\"><span class=\"input-group-text rounded-0 fs-14 fw-bold text-primary\"> $ </span><input type=\"text\" class=\"form-control shadow-none rounded-0 text-black\" placeholder=\"e.g. 120.00\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group mb-15 mb-sm-20 mb-md-25\"><label class=\"d-block text-black fw-semibold mb-10\"> Discount </label><div class=\"input-group\"><span class=\"input-group-text rounded-0 fs-14 fw-bold text-primary\"> % </span><input type=\"text\" class=\"form-control shadow-none rounded-0 text-black\" placeholder=\"e.g. 15\"></div></div></div><div class=\"col-md-12\"><div class=\"form-group mb-15 mb-sm-20 mb-md-25\"><label class=\"d-block text-black fw-semibold mb-10\"> Select Tags </label><input type=\"text\" class=\"form-control shadow-none rounded-0 text-black\" placeholder=\"e.g. AI\"><div class=\"members-list\"><div class=\"d-inline-block bg-gray rounded-1 fs-12 fw-medium text-primary p-5\"> Machine Learning <button type=\"button\" class=\"bg-transparent p-0 border-0 lh-1 transition\"><i class=\"flaticon-close\"></i></button></div><div class=\"d-inline-block bg-gray rounded-1 fs-12 fw-medium text-primary p-5\"> App Dev <button type=\"button\" class=\"bg-transparent p-0 border-0 lh-1 transition\"><i class=\"flaticon-close\"></i></button></div><div class=\"d-inline-block bg-gray rounded-1 fs-12 fw-medium text-primary p-5\"> Design <button type=\"button\" class=\"bg-transparent p-0 border-0 lh-1 transition\"><i class=\"flaticon-close\"></i></button></div></div></div></div>", 4)),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _cache[1] || (_cache[1] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Course Preview Image ", -1)),
              _createVNode(_component_ImageUpload)
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _cache[57] || (_cache[57] = _createElementVNode("h5", { class: "fw-bold text-black mb-12 mb-md-15 mb-lg-20" }, " Course Sections ", -1)),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _cache[12] || (_cache[12] = _createStaticVNode("<button class=\"accordion-button d-block w-100 text-start text-black fs-14 fs-md-15 fs-lg-16 fw-medium rounded-0 bg-white border-0\" type=\"button\" data-bs-toggle=\"collapse\" data-bs-target=\"#TableContentCollapseOne\" aria-expanded=\"true\" aria-controls=\"TableContentCollapseOne\"><div class=\"d-sm-flex align-items-center justify-content-between\"><div class=\"d-flex align-items-center\"><div class=\"number bg-primary text-center text-white rounded-circle fs-13 fw-semibold\"> 1 </div> Welcome to the course! </div><ul class=\"d-flex align-items-center mt-10 mt-sm-0 ps-0 mb-0 list-unstyled\"><li class=\"position-relative fw-medium fs-14 text-muted\"><i class=\"flaticon-book\"></i> 5 lectures </li><li class=\"position-relative fw-medium fs-14 text-muted\"><i class=\"flaticon-clock\"></i> 11 mins </li></ul></div></button>", 1)),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("ul", _hoisted_14, [
                      _createElementVNode("li", _hoisted_15, [
                        _createVNode(_component_router_link, {
                          to: "/lessons-preview",
                          class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                        }, {
                          default: _withCtx(() => _cache[2] || (_cache[2] = [
                            _createElementVNode("i", { class: "flaticon-play" }, null, -1),
                            _createTextVNode(" Welcome Challenge! ", -1)
                          ])),
                          _: 1,
                          __: [2]
                        }),
                        _cache[3] || (_cache[3] = _createElementVNode("span", { class: "text-muted fw-medium" }, "01:22", -1))
                      ]),
                      _createElementVNode("li", _hoisted_16, [
                        _createVNode(_component_router_link, {
                          to: "/lessons-preview",
                          class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                        }, {
                          default: _withCtx(() => _cache[4] || (_cache[4] = [
                            _createElementVNode("i", { class: "flaticon-play" }, null, -1),
                            _createTextVNode(" Why AI? ", -1)
                          ])),
                          _: 1,
                          __: [4]
                        }),
                        _cache[5] || (_cache[5] = _createElementVNode("span", { class: "text-muted fw-medium" }, "05:10", -1))
                      ]),
                      _createElementVNode("li", _hoisted_17, [
                        _createVNode(_component_router_link, {
                          to: "/lessons-preview",
                          class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                        }, {
                          default: _withCtx(() => _cache[6] || (_cache[6] = [
                            _createElementVNode("i", { class: "flaticon-play" }, null, -1),
                            _createTextVNode(" Course Structure ", -1)
                          ])),
                          _: 1,
                          __: [6]
                        }),
                        _cache[7] || (_cache[7] = _createElementVNode("span", { class: "text-muted fw-medium" }, "00:46", -1))
                      ]),
                      _createElementVNode("li", _hoisted_18, [
                        _createVNode(_component_router_link, {
                          to: "/lessons-preview",
                          class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                        }, {
                          default: _withCtx(() => _cache[8] || (_cache[8] = [
                            _createElementVNode("i", { class: "flaticon-play" }, null, -1),
                            _createTextVNode(" Installing Anaconda ", -1)
                          ])),
                          _: 1,
                          __: [8]
                        }),
                        _cache[9] || (_cache[9] = _createElementVNode("span", { class: "text-muted fw-medium" }, "03:26", -1))
                      ]),
                      _createElementVNode("li", _hoisted_19, [
                        _createVNode(_component_router_link, {
                          to: "/lessons-preview",
                          class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                        }, {
                          default: _withCtx(() => _cache[10] || (_cache[10] = [
                            _createElementVNode("i", { class: "flaticon-play" }, null, -1),
                            _createTextVNode(" Use ChatGPT to Build AI More Efficiently ", -1)
                          ])),
                          _: 1,
                          __: [10]
                        }),
                        _cache[11] || (_cache[11] = _createElementVNode("span", { class: "text-muted fw-medium" }, "00:23", -1))
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _cache[23] || (_cache[23] = _createStaticVNode("<button class=\"accordion-button collapsed d-block w-100 text-start text-black fs-14 fs-md-15 fs-lg-16 fw-medium rounded-0 bg-white border-0\" type=\"button\" data-bs-toggle=\"collapse\" data-bs-target=\"#TableContentCollapseTwo\" aria-expanded=\"true\" aria-controls=\"TableContentCollapseTwo\"><div class=\"d-sm-flex align-items-center justify-content-between\"><div class=\"d-flex align-items-center\"><div class=\"number bg-primary text-center text-white rounded-circle fs-13 fw-semibold\"> 2 </div> Python Setup </div><ul class=\"d-flex align-items-center mt-10 mt-sm-0 ps-0 mb-0 list-unstyled\"><li class=\"position-relative fw-medium fs-14 text-muted\"><i class=\"flaticon-book\"></i> 6 lectures </li><li class=\"position-relative fw-medium fs-14 text-muted\"><i class=\"flaticon-clock\"></i> 12 mins </li></ul></div></button>", 1)),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("ul", _hoisted_23, [
                      _createElementVNode("li", _hoisted_24, [
                        _createVNode(_component_router_link, {
                          to: "/lessons-preview",
                          class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                        }, {
                          default: _withCtx(() => _cache[13] || (_cache[13] = [
                            _createElementVNode("i", { class: "flaticon-play" }, null, -1),
                            _createTextVNode(" Welcome Challenge! ", -1)
                          ])),
                          _: 1,
                          __: [13]
                        }),
                        _cache[14] || (_cache[14] = _createElementVNode("span", { class: "text-muted fw-medium" }, "01:22", -1))
                      ]),
                      _createElementVNode("li", _hoisted_25, [
                        _createVNode(_component_router_link, {
                          to: "/lessons-preview",
                          class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                        }, {
                          default: _withCtx(() => _cache[15] || (_cache[15] = [
                            _createElementVNode("i", { class: "flaticon-play" }, null, -1),
                            _createTextVNode(" Why AI? ", -1)
                          ])),
                          _: 1,
                          __: [15]
                        }),
                        _cache[16] || (_cache[16] = _createElementVNode("span", { class: "text-muted fw-medium" }, "05:10", -1))
                      ]),
                      _createElementVNode("li", _hoisted_26, [
                        _createVNode(_component_router_link, {
                          to: "/lessons-preview",
                          class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                        }, {
                          default: _withCtx(() => _cache[17] || (_cache[17] = [
                            _createElementVNode("i", { class: "flaticon-play" }, null, -1),
                            _createTextVNode(" Course Structure ", -1)
                          ])),
                          _: 1,
                          __: [17]
                        }),
                        _cache[18] || (_cache[18] = _createElementVNode("span", { class: "text-muted fw-medium" }, "00:46", -1))
                      ]),
                      _createElementVNode("li", _hoisted_27, [
                        _createVNode(_component_router_link, {
                          to: "/lessons-preview",
                          class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                        }, {
                          default: _withCtx(() => _cache[19] || (_cache[19] = [
                            _createElementVNode("i", { class: "flaticon-play" }, null, -1),
                            _createTextVNode(" Installing Anaconda ", -1)
                          ])),
                          _: 1,
                          __: [19]
                        }),
                        _cache[20] || (_cache[20] = _createElementVNode("span", { class: "text-muted fw-medium" }, "03:26", -1))
                      ]),
                      _createElementVNode("li", _hoisted_28, [
                        _createVNode(_component_router_link, {
                          to: "/lessons-preview",
                          class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                        }, {
                          default: _withCtx(() => _cache[21] || (_cache[21] = [
                            _createElementVNode("i", { class: "flaticon-play" }, null, -1),
                            _createTextVNode(" Use ChatGPT to Build AI More Efficiently ", -1)
                          ])),
                          _: 1,
                          __: [21]
                        }),
                        _cache[22] || (_cache[22] = _createElementVNode("span", { class: "text-muted fw-medium" }, "00:23", -1))
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_29, [
                _cache[34] || (_cache[34] = _createStaticVNode("<button class=\"accordion-button collapsed d-block w-100 text-start text-black fs-14 fs-md-15 fs-lg-16 fw-medium rounded-0 bg-white border-0\" type=\"button\" data-bs-toggle=\"collapse\" data-bs-target=\"#TableContentCollapseThree\" aria-expanded=\"true\" aria-controls=\"TableContentCollapseThree\"><div class=\"d-sm-flex align-items-center justify-content-between\"><div class=\"d-flex align-items-center\"><div class=\"number bg-primary text-center text-white rounded-circle fs-13 fw-semibold\"> 3 </div> Python Objects &amp; Data Structures Basics </div><ul class=\"d-flex align-items-center mt-10 mt-sm-0 ps-0 mb-0 list-unstyled\"><li class=\"position-relative fw-medium fs-14 text-muted\"><i class=\"flaticon-book\"></i> 8 lectures </li><li class=\"position-relative fw-medium fs-14 text-muted\"><i class=\"flaticon-clock\"></i> 43 mins </li></ul></div></button>", 1)),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("ul", _hoisted_32, [
                      _createElementVNode("li", _hoisted_33, [
                        _createVNode(_component_router_link, {
                          to: "/lessons-preview",
                          class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                        }, {
                          default: _withCtx(() => _cache[24] || (_cache[24] = [
                            _createElementVNode("i", { class: "flaticon-play" }, null, -1),
                            _createTextVNode(" Welcome Challenge! ", -1)
                          ])),
                          _: 1,
                          __: [24]
                        }),
                        _cache[25] || (_cache[25] = _createElementVNode("span", { class: "text-muted fw-medium" }, "01:22", -1))
                      ]),
                      _createElementVNode("li", _hoisted_34, [
                        _createVNode(_component_router_link, {
                          to: "/lessons-preview",
                          class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                        }, {
                          default: _withCtx(() => _cache[26] || (_cache[26] = [
                            _createElementVNode("i", { class: "flaticon-play" }, null, -1),
                            _createTextVNode(" Why AI? ", -1)
                          ])),
                          _: 1,
                          __: [26]
                        }),
                        _cache[27] || (_cache[27] = _createElementVNode("span", { class: "text-muted fw-medium" }, "05:10", -1))
                      ]),
                      _createElementVNode("li", _hoisted_35, [
                        _createVNode(_component_router_link, {
                          to: "/lessons-preview",
                          class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                        }, {
                          default: _withCtx(() => _cache[28] || (_cache[28] = [
                            _createElementVNode("i", { class: "flaticon-play" }, null, -1),
                            _createTextVNode(" Course Structure ", -1)
                          ])),
                          _: 1,
                          __: [28]
                        }),
                        _cache[29] || (_cache[29] = _createElementVNode("span", { class: "text-muted fw-medium" }, "00:46", -1))
                      ]),
                      _createElementVNode("li", _hoisted_36, [
                        _createVNode(_component_router_link, {
                          to: "/lessons-preview",
                          class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                        }, {
                          default: _withCtx(() => _cache[30] || (_cache[30] = [
                            _createElementVNode("i", { class: "flaticon-play" }, null, -1),
                            _createTextVNode(" Installing Anaconda ", -1)
                          ])),
                          _: 1,
                          __: [30]
                        }),
                        _cache[31] || (_cache[31] = _createElementVNode("span", { class: "text-muted fw-medium" }, "03:26", -1))
                      ]),
                      _createElementVNode("li", _hoisted_37, [
                        _createVNode(_component_router_link, {
                          to: "/lessons-preview",
                          class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                        }, {
                          default: _withCtx(() => _cache[32] || (_cache[32] = [
                            _createElementVNode("i", { class: "flaticon-play" }, null, -1),
                            _createTextVNode(" Use ChatGPT to Build AI More Efficiently ", -1)
                          ])),
                          _: 1,
                          __: [32]
                        }),
                        _cache[33] || (_cache[33] = _createElementVNode("span", { class: "text-muted fw-medium" }, "00:23", -1))
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_38, [
                _cache[45] || (_cache[45] = _createStaticVNode("<button class=\"accordion-button collapsed d-block w-100 text-start text-black fs-14 fs-md-15 fs-lg-16 fw-medium rounded-0 bg-white border-0\" type=\"button\" data-bs-toggle=\"collapse\" data-bs-target=\"#TableContentCollapseFour\" aria-expanded=\"true\" aria-controls=\"TableContentCollapseFour\"><div class=\"d-sm-flex align-items-center justify-content-between\"><div class=\"d-flex align-items-center\"><div class=\"number bg-primary text-center text-white rounded-circle fs-13 fw-semibold\"> 4 </div> Python Comparison Operators </div><ul class=\"d-flex align-items-center mt-10 mt-sm-0 ps-0 mb-0 list-unstyled\"><li class=\"position-relative fw-medium fs-14 text-muted\"><i class=\"flaticon-book\"></i> 3 lectures </li><li class=\"position-relative fw-medium fs-14 text-muted\"><i class=\"flaticon-clock\"></i> 33 mins </li></ul></div></button>", 1)),
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("ul", _hoisted_41, [
                      _createElementVNode("li", _hoisted_42, [
                        _createVNode(_component_router_link, {
                          to: "/lessons-preview",
                          class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                        }, {
                          default: _withCtx(() => _cache[35] || (_cache[35] = [
                            _createElementVNode("i", { class: "flaticon-play" }, null, -1),
                            _createTextVNode(" Welcome Challenge! ", -1)
                          ])),
                          _: 1,
                          __: [35]
                        }),
                        _cache[36] || (_cache[36] = _createElementVNode("span", { class: "text-muted fw-medium" }, "01:22", -1))
                      ]),
                      _createElementVNode("li", _hoisted_43, [
                        _createVNode(_component_router_link, {
                          to: "/lessons-preview",
                          class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                        }, {
                          default: _withCtx(() => _cache[37] || (_cache[37] = [
                            _createElementVNode("i", { class: "flaticon-play" }, null, -1),
                            _createTextVNode(" Why AI? ", -1)
                          ])),
                          _: 1,
                          __: [37]
                        }),
                        _cache[38] || (_cache[38] = _createElementVNode("span", { class: "text-muted fw-medium" }, "05:10", -1))
                      ]),
                      _createElementVNode("li", _hoisted_44, [
                        _createVNode(_component_router_link, {
                          to: "/lessons-preview",
                          class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                        }, {
                          default: _withCtx(() => _cache[39] || (_cache[39] = [
                            _createElementVNode("i", { class: "flaticon-play" }, null, -1),
                            _createTextVNode(" Course Structure ", -1)
                          ])),
                          _: 1,
                          __: [39]
                        }),
                        _cache[40] || (_cache[40] = _createElementVNode("span", { class: "text-muted fw-medium" }, "00:46", -1))
                      ]),
                      _createElementVNode("li", _hoisted_45, [
                        _createVNode(_component_router_link, {
                          to: "/lessons-preview",
                          class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                        }, {
                          default: _withCtx(() => _cache[41] || (_cache[41] = [
                            _createElementVNode("i", { class: "flaticon-play" }, null, -1),
                            _createTextVNode(" Installing Anaconda ", -1)
                          ])),
                          _: 1,
                          __: [41]
                        }),
                        _cache[42] || (_cache[42] = _createElementVNode("span", { class: "text-muted fw-medium" }, "03:26", -1))
                      ]),
                      _createElementVNode("li", _hoisted_46, [
                        _createVNode(_component_router_link, {
                          to: "/lessons-preview",
                          class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                        }, {
                          default: _withCtx(() => _cache[43] || (_cache[43] = [
                            _createElementVNode("i", { class: "flaticon-play" }, null, -1),
                            _createTextVNode(" Use ChatGPT to Build AI More Efficiently ", -1)
                          ])),
                          _: 1,
                          __: [43]
                        }),
                        _cache[44] || (_cache[44] = _createElementVNode("span", { class: "text-muted fw-medium" }, "00:23", -1))
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_47, [
                _cache[56] || (_cache[56] = _createStaticVNode("<button class=\"accordion-button collapsed d-block w-100 text-start text-black fs-14 fs-md-15 fs-lg-16 fw-medium rounded-0 bg-white border-0\" type=\"button\" data-bs-toggle=\"collapse\" data-bs-target=\"#TableContentCollapseFive\" aria-expanded=\"true\" aria-controls=\"TableContentCollapseFive\"><div class=\"d-sm-flex align-items-center justify-content-between\"><div class=\"d-flex align-items-center\"><div class=\"number bg-primary text-center text-white rounded-circle fs-13 fw-semibold\"> 5 </div> Python Statements </div><ul class=\"d-flex align-items-center mt-10 mt-sm-0 ps-0 mb-0 list-unstyled\"><li class=\"position-relative fw-medium fs-14 text-muted\"><i class=\"flaticon-book\"></i> 10 lectures </li><li class=\"position-relative fw-medium fs-14 text-muted\"><i class=\"flaticon-clock\"></i> 1 hour </li></ul></div></button>", 1)),
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("ul", _hoisted_50, [
                      _createElementVNode("li", _hoisted_51, [
                        _createVNode(_component_router_link, {
                          to: "/lessons-preview",
                          class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                        }, {
                          default: _withCtx(() => _cache[46] || (_cache[46] = [
                            _createElementVNode("i", { class: "flaticon-play" }, null, -1),
                            _createTextVNode(" Welcome Challenge! ", -1)
                          ])),
                          _: 1,
                          __: [46]
                        }),
                        _cache[47] || (_cache[47] = _createElementVNode("span", { class: "text-muted fw-medium" }, "01:22", -1))
                      ]),
                      _createElementVNode("li", _hoisted_52, [
                        _createVNode(_component_router_link, {
                          to: "/lessons-preview",
                          class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                        }, {
                          default: _withCtx(() => _cache[48] || (_cache[48] = [
                            _createElementVNode("i", { class: "flaticon-play" }, null, -1),
                            _createTextVNode(" Why AI? ", -1)
                          ])),
                          _: 1,
                          __: [48]
                        }),
                        _cache[49] || (_cache[49] = _createElementVNode("span", { class: "text-muted fw-medium" }, "05:10", -1))
                      ]),
                      _createElementVNode("li", _hoisted_53, [
                        _createVNode(_component_router_link, {
                          to: "/lessons-preview",
                          class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                        }, {
                          default: _withCtx(() => _cache[50] || (_cache[50] = [
                            _createElementVNode("i", { class: "flaticon-play" }, null, -1),
                            _createTextVNode(" Course Structure ", -1)
                          ])),
                          _: 1,
                          __: [50]
                        }),
                        _cache[51] || (_cache[51] = _createElementVNode("span", { class: "text-muted fw-medium" }, "00:46", -1))
                      ]),
                      _createElementVNode("li", _hoisted_54, [
                        _createVNode(_component_router_link, {
                          to: "/lessons-preview",
                          class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                        }, {
                          default: _withCtx(() => _cache[52] || (_cache[52] = [
                            _createElementVNode("i", { class: "flaticon-play" }, null, -1),
                            _createTextVNode(" Installing Anaconda ", -1)
                          ])),
                          _: 1,
                          __: [52]
                        }),
                        _cache[53] || (_cache[53] = _createElementVNode("span", { class: "text-muted fw-medium" }, "03:26", -1))
                      ]),
                      _createElementVNode("li", _hoisted_55, [
                        _createVNode(_component_router_link, {
                          to: "/lessons-preview",
                          class: "fs-md-15 text-muted fw-medium text-decoration-none position-relative"
                        }, {
                          default: _withCtx(() => _cache[54] || (_cache[54] = [
                            _createElementVNode("i", { class: "flaticon-play" }, null, -1),
                            _createTextVNode(" Use ChatGPT to Build AI More Efficiently ", -1)
                          ])),
                          _: 1,
                          __: [54]
                        }),
                        _cache[55] || (_cache[55] = _createElementVNode("span", { class: "text-muted fw-medium" }, "00:23", -1))
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _cache[60] || (_cache[60] = _createStaticVNode("<div class=\"col-md-12\"><h5 class=\"fw-bold text-black mb-12 mb-md-15 mb-lg-20\"> Add More Sections </h5></div><div class=\"col-md-6\"><div class=\"form-group mb-15 mb-sm-20 mb-md-25\"><label class=\"d-block text-black fw-semibold mb-10\"> Section Title </label><input type=\"text\" class=\"form-control shadow-none rounded-0 text-black\" placeholder=\"e.g. Introduction\"></div></div><div class=\"col-md-6\"><div class=\"form-group mb-15 mb-sm-20 mb-md-25\"><label class=\"d-block text-black fw-semibold mb-10\"> Duration </label><input type=\"text\" class=\"form-control shadow-none rounded-0 text-black\" placeholder=\"e.g. 1:25\"></div></div><div class=\"col-md-6\"><div class=\"form-group mb-15 mb-sm-20 mb-md-25\"><label class=\"d-block text-black fw-semibold mb-10\"> Sub-section Title </label><input type=\"text\" class=\"form-control shadow-none rounded-0 text-black\" placeholder=\"e.g. Introduction\"></div></div><div class=\"col-md-6\"><div class=\"form-group mb-15 mb-sm-20 mb-md-25\"><label class=\"d-block text-black fw-semibold mb-10\"> Sub-section Duration </label><input type=\"text\" class=\"form-control shadow-none rounded-0 text-black\" placeholder=\"e.g. 4:32\"></div></div><div class=\"col-md-12\"><div class=\"form-group mb-15 mb-sm-20 mb-md-25\"><label class=\"d-block text-black fw-semibold mb-10\"> Upload Video Or Content </label><div class=\"file-upload text-center position-relative\"><i class=\"flaticon-video\"></i><span class=\"d-block text-muted\"> Drop Files Here Or <span class=\"text-black fw-medium position-relative\"> Click To Upload </span></span><input type=\"file\" class=\"d-block shadow-none border-0 position-absolute start-0 end-0 top-0 bottom-0 z-1 opacity-0\"></div></div></div><div class=\"col-md-12\"><div class=\"d-flex align-items-center justify-content-between\"><button class=\"default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success\" type=\"submit\"> Save Course </button><button type=\"button\" class=\"bg-transparent p-0 border-0 text-danger lh-1 fw-medium\"><i class=\"flaticon-delete lh-1 me-1 position-relative top-2\"></i><span class=\"position-relative\">Delete Course</span></button></div></div>", 7))
        ])
      ])
    ])
  ]))
}